function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2473 15.2583C11.1525 15.4213 11.2052 15.6301 11.3661 15.7287L15.7593 18.4187C15.9162 18.5147 16.1089 18.6176 16.2881 18.5117L20.8488 15.8184C21.0149 15.7202 21.0692 15.5056 20.9695 15.3404L16.4088 7.78022C16.2434 7.50602 15.9207 7.50278 15.7593 7.78022L11.2473 15.2583ZM20.0381 15.4907L20.19 15.3931L20.1935 15.3989L20.0381 15.4907Z",
  fill: "#12C0A1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.03 19.899L11.7862 17.2922C11.7862 17.2922 11.4462 17.3832 11.5517 17.5379C11.6572 17.6925 15.6709 23.5734 15.6709 23.5734C15.8199 23.7917 16.2591 23.7761 16.4098 23.564L20.6978 17.5317C20.8063 17.3791 20.6293 17.1866 20.4678 17.2818L16.03 19.899ZM18.6552 18.1382L18.7156 18.0547L18.7113 18.0572L18.6552 18.1382Z",
  fill: "#12C0A1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0003 28C22.6277 28 28.0003 22.6274 28.0003 16C28.0003 9.37258 22.6277 4 16.0003 4C9.37291 4 4.00033 9.37258 4.00033 16C4.00033 22.6274 9.37291 28 16.0003 28ZM16.0003 29.3333C23.3641 29.3333 29.3337 23.3638 29.3337 16C29.3337 8.6362 23.3641 2.66667 16.0003 2.66667C8.63653 2.66667 2.66699 8.6362 2.66699 16C2.66699 23.3638 8.63653 29.3333 16.0003 29.3333Z",
  fill: "#12C0A1"
});

const SvgEth = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEth, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eth.2e2d5953.svg";
export { ForwardRef as ReactComponent };